module.exports = __webpack_public_path__ + "static/img/h4-3.48dc774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h4-3.png
// module id = HBV6
// module chunks = 1